import React, { useState } from 'react';
import { Phone, Send, CheckCircle, Clock, Shield, Award } from 'lucide-react';
import { contactInfo } from '../mockData';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    city: '',
    message: ''
  });
  
  const [submitted, setSubmitted] = useState(false);
  
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        city: '',
        message: ''
      });
    }, 3000);
  };
  
  return (
    <section id="contact" className="py-16 md:py-32 px-4 relative overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://images.pexels.com/photos/6944915/pexels-photo-6944915.jpeg"
          alt="Contact Background"
          className="w-full h-full object-cover opacity-5"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black via-black/95 to-black"></div>
      </div>
      
      <div className="container mx-auto relative z-10">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 display-font">
            <span className="gold-text">Contactez-nous</span>
          </h2>
          <div className="w-32 h-1 divider-glow mx-auto mb-6"></div>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto serif-font">
            Discrétion absolue garantie pour tous vos besoins spirituels
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
          <div className="space-y-8">
            <div className="glass rounded-3xl p-8">
              <h3 className="text-3xl font-bold text-white mb-8 display-font">Informations de contact</h3>
              
              <div className="space-y-6">
                <div className="flex items-start space-x-5">
                  <div className="w-14 h-14 bg-gradient-to-br from-yellow-600 to-amber-600 rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg">
                    <Phone className="text-white" size={28} />
                  </div>
                  <div>
                    <p className="text-gray-400 mb-2 text-sm">Téléphone</p>
                    <a href={`tel:${contactInfo.phone}`} className="text-white text-2xl font-bold hover:text-yellow-500 transition-colors">
                      {contactInfo.phone}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="glass rounded-3xl p-8">
              <h4 className="text-white font-bold text-2xl mb-6 display-font flex items-center">
                <Clock className="text-yellow-500 mr-3" size={28} />
                {contactInfo.availability}
              </h4>
              <p className="text-gray-400 leading-relaxed text-lg">
                Nous sommes disponibles à tout moment pour répondre à vos questions et vous aider à résoudre vos problèmes.
              </p>
            </div>
            
            <div className="glass rounded-3xl p-8">
              <h4 className="text-white font-bold text-2xl mb-6 display-font">Pourquoi nous choisir ?</h4>
              <ul className="space-y-4">
                <li className="flex items-start space-x-3">
                  <CheckCircle className="text-yellow-500 flex-shrink-0 mt-1" size={24} />
                  <span className="text-gray-300 text-lg">Résultats dans la même semaine</span>
                </li>
                <li className="flex items-start space-x-3">
                  <Award className="text-yellow-500 flex-shrink-0 mt-1" size={24} />
                  <span className="text-gray-300 text-lg">Plus de 20 ans d'expérience</span>
                </li>
                <li className="flex items-start space-x-3">
                  <Shield className="text-yellow-500 flex-shrink-0 mt-1" size={24} />
                  <span className="text-gray-300 text-lg">Discrétion absolue assurée</span>
                </li>
              </ul>
            </div>
          </div>
          
          <div>
            <div className="glass rounded-3xl p-10">
              <h3 className="text-3xl font-bold text-white mb-8 display-font">Demande de consultation</h3>
              
              {submitted ? (
                <div className="text-center py-16">
                  <div className="w-20 h-20 bg-gradient-to-br from-green-600 to-green-700 rounded-full flex items-center justify-center mx-auto mb-6 animate-glow">
                    <CheckCircle className="text-white" size={48} />
                  </div>
                  <h4 className="text-white text-3xl font-bold mb-3 display-font">Message envoyé !</h4>
                  <p className="text-gray-400 text-lg">Nous vous contacterons dans les plus brefs délais.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <label className="text-white mb-3 block font-semibold text-lg">Nom complet *</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full glass border-2 border-white/20 rounded-2xl px-6 py-4 text-white placeholder-gray-400 focus:outline-none focus:border-yellow-500 transition-all text-lg"
                      placeholder="Votre nom"
                    />
                  </div>
                  
                  <div>
                    <label className="text-white mb-3 block font-semibold text-lg">Email *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full glass border-2 border-white/20 rounded-2xl px-6 py-4 text-white placeholder-gray-400 focus:outline-none focus:border-yellow-500 transition-all text-lg"
                      placeholder="votre@email.com"
                    />
                  </div>
                  
                  <div>
                    <label className="text-white mb-3 block font-semibold text-lg">Téléphone *</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      className="w-full glass border-2 border-white/20 rounded-2xl px-6 py-4 text-white placeholder-gray-400 focus:outline-none focus:border-yellow-500 transition-all text-lg"
                      placeholder="+32 XXX XX XX XX"
                    />
                  </div>
                  
                  <div>
                    <label className="text-white mb-3 block font-semibold text-lg">Ville</label>
                    <input
                      type="text"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      className="w-full glass border-2 border-white/20 rounded-2xl px-6 py-4 text-white placeholder-gray-400 focus:outline-none focus:border-yellow-500 transition-all text-lg"
                      placeholder="Votre ville en Belgique"
                    />
                  </div>
                  
                  <div>
                    <label className="text-white mb-3 block font-semibold text-lg">Votre demande *</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="5"
                      className="w-full glass border-2 border-white/20 rounded-2xl px-6 py-4 text-white placeholder-gray-400 focus:outline-none focus:border-yellow-500 transition-all resize-none text-lg"
                      placeholder="Décrivez votre situation..."
                    ></textarea>
                  </div>
                  
                  <button
                    type="submit"
                    className="w-full luxury-button text-white px-6 py-5 rounded-2xl font-bold text-xl flex items-center justify-center space-x-3"
                  >
                    <Send size={24} />
                    <span>Envoyer ma demande</span>
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;